import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './assets/css/fontsFace.css'
import './assets/css/main.css'
import './assets/css/tailwind.css'

createApp(App)
  .use(store)
  .use(router)
  .mount('#app')
